import { Fragment, useRef } from 'react';

import { InfoTitle } from '../../../../../components/Toolkit/InfoTitle/InfoTitle';
import { LineClamp } from '../../../../../components/Toolkit/LineClamp/LineClamp';
import { WithLink } from '../../../../../components/ToolkitV2/CardV2/enhancements/WithLink/WithLink';

import {
  CARD_ORIENTATION,
  CARD_PADDING,
} from '../../../../../features/PreviousSearches/PreviousSearches.constants';

import {
  SavedSearchCard as SavedSearchCardStyled,
  SavedSearchIcon,
} from '../../../../../features/PreviousSearches/PreviousSearchesModal/components/SavedSearches/SavedSearches.styled';

import { Spacer } from '../../../../../helpers/genericStyles';
import { getSavedSearchUrl } from '../../../../../components/Dashboard/pages/SavedSearches/helpers/url';
import { accessibleOnClick } from '../../../../../utils/Accessibility';
import { FEATURE_TRIMS_FILTER } from '../../../../../utils';
import { useTruncatedTerms } from '../../../../../hooks/useTruncatedTerms';

import type { ISavedSearch } from '../../../../../api/types/savedSearchApiTypes';

type SavedSearchCardProps = {
  savedSearch: ISavedSearch;
  onClickSavedSearch: () => void;
};

const SavedSearchCard = (props: SavedSearchCardProps) => {
  const { savedSearch, onClickSavedSearch } = props;
  const containerRef = useRef<HTMLUListElement>(null);

  const href = getSavedSearchUrl(savedSearch);
  const { description } = savedSearch;

  const { truncatedText } = useTruncatedTerms({
    description,
    containerRef,
  });

  return (
    <Fragment key={`previous-searches-saved-search-${savedSearch.id}`}>
      <Spacer marginBottom={['M16']} />
      <li
        key={savedSearch.id}
        {...accessibleOnClick(onClickSavedSearch)}
        data-tracking="saved_search_card"
      >
        <WithLink href={href} shallow>
          <SavedSearchCardStyled
            header={
              <InfoTitle
                title={savedSearch.name}
                listItems={[
                  FEATURE_TRIMS_FILTER ? (
                    <LineClamp key={savedSearch.id} lines={1}>
                      <div>{truncatedText}</div>
                    </LineClamp>
                  ) : (
                    <LineClamp key={savedSearch.id} lines={1}>
                      {description}
                    </LineClamp>
                  ),
                ]}
                icon={<SavedSearchIcon height={24} width={24} />}
                variant="XS"
                metaListRef={FEATURE_TRIMS_FILTER ? containerRef : undefined}
              />
            }
            paddingSmall={CARD_PADDING}
            orientationSmall={CARD_ORIENTATION}
          />
        </WithLink>
      </li>
    </Fragment>
  );
};

export { SavedSearchCard };
